// import React, { useState, useEffect, useRef } from "react";
// import "./OTC.css";
// import copy_image from "./../../Assets/Images/CreateBatch/copy_icon.png";
// import DropdownWithPagination from "../StudentGrouph/DropdownWithPagination";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import InfoIcon from "../../Assets/Images/CommanImages/Informative.png";
// import EndPoints from "../../Api/EndPoints";

// const GenerateOTLC = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setNoTimeSet,
//   setShowCloseButton,
// }) => {
//   const [otlc, setOtlc] = useState("");
//   const [selectedStudent, setSelectedStudent] = useState([]);
//   const [studentOptions, setStudentOptions] = useState([]);
//   const [isOpenDetails, setIsOpenDetails] = useState(true);
//   const [studentDetail, setStudentDetail] = useState({
//     roll_number: "",
//     student_full_name: "",
//     status: "",
//     class_type: "",
//     course_name: "",
//     batch_name: "",
//     mobile_number: "",
//   });

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
//   const clientBranchId = dataClient?.client_schema_name[6][0].client_branch_id;
//   const screenArray = dataClient?.client_schema_name?.[2] || [];
//   const studentAccessScreen = screenArray.find(screen => screen.LVL2 === "Student access");
//   const screenId = studentAccessScreen?.screen_id || 0;
  
//   const toggleAccordionDetails = () => setIsOpenDetails((prev) => !prev);

//   const fetchStudents = async (searchKeyInput) => {
//     // Clear options if search input is empty or less than 3 characters
//     if (!searchKeyInput || String(searchKeyInput).trim().length < 3) {
//       setStudentOptions([]);
//       return;
//     }

//     try {
//       const trimmedSearch = String(searchKeyInput).trim();
      
//       const response = await fetch(
//         `${EndPoints.GET_STUDENT_BY_SEARCH_KEY}?search_key=${encodeURIComponent(trimmedSearch)}`,
//         {
//           headers: {
//             Accept: "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         console.error(`HTTP error! status: ${response.status}`);
//         setStudentOptions([]);
//         return;
//       }

//       const data = await response.json();
      
//       // Handle different response formats
//       const studentArray = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

//       // Format options for dropdown
//       const formattedOptions = studentArray.map((student) => ({
//         id: student.roll_number,
//         label: `${student.student_full_name} (${student.roll_number})`,
//         fullData: student,
//       }));

//       // Update state with new options
//       setStudentOptions(formattedOptions);
      
//       // Log for debugging
//       console.log(`Search: "${trimmedSearch}" - Found ${formattedOptions.length} results`);
//     } catch (error) {
//       console.error("Error fetching students:", error);
//       setStudentOptions([]);
//     }
//   };

//   useEffect(() => {
//     if (!selectedStudent || selectedStudent.length === 0) {
//       setStudentDetail({
//         roll_number: "",
//         student_full_name: "",
//         status: "",
//         class_type: "",
//         course_name: "",
//         batch_name: "",
//         mobile_number: "",
//       });
//       return;
//     }

//     const selId = String(selectedStudent[0]);
//     const found = studentOptions.find((o) => String(o.id) === selId);

//     if (found && found.fullData) {
//       setStudentDetail(found.fullData);
//     }
//   }, [selectedStudent, studentOptions]);

//   const generateOtc = async () => {
//     if (!selectedStudent || selectedStudent.length === 0) {
//       setShowCloseButton(true);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please select a student first</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${EndPoints.GENERATE_STUDENT_OTLC_V2}?roll_number=${selectedStudent[0]}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             user_name: userName,
//             client_branch_id: clientBranchId,
//             screen_event_id: 37,
//             screen_id: screenId,
//           }),
//         }
//       );

//       const data = await response.json();
//       if (!response.ok || data.status_code !== 200) {
//         setShowCloseButton(false);
//         setNoTimeSet(false); 
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{data.message || "Failed to generate OTLC"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         return;
//       }

//       const generatedOtlc = data.otlc || "";
//       setOtlc(generatedOtlc);

//       if (generatedOtlc) {
//         navigator.clipboard.writeText(generatedOtlc);
//       }

//       // SET noTimeSet to true so message box DOES NOT auto-close
//       setNoTimeSet(true);
//       setShowCloseButton(true);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ cursor: "pointer" }}>
//               {data.message || "OTLC created successfully"} and copied to clipboard.{" "}
//               <strong>Code: {generatedOtlc}</strong>
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(InfoIcon);
//     } catch (error) {
//       console.error("Error generating OTLC:", error);
//       setShowCloseButton(false);
//       setNoTimeSet(false); // Allow auto-close for error
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>An error occurred while generating OTLC</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//     }
//   };


//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Generate One Time Login Code</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-create-btn" onClick={generateOtc} style={{width: "180px"}}>
//             GENERATE OTLC
//           </button>
//         </div>
//       </div>

//       <div style={{ width: "490px", marginBottom: "20px" }}>
//         <DropdownWithPagination
//           label="Select Student"
//           width="100%"
//           selected={selectedStudent}
//           setSelected={setSelectedStudent}
//           onSearchInputChange={fetchStudents}
//           options={studentOptions}
//           isRequired={true}
//           showSelectAll={false}
//           allowMultiple={false}
//           itemsPerPage={4}
//         />
//       </div>

//       {/* STUDENT DETAILS */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>STUDENT DETAILS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionDetails}>
//             {isOpenDetails ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>

//         {isOpenDetails && (
//           <div className="accordion-content">
//             <div
//               className="select-assign-test-container-ques-pap-del"
//               style={{ padding: "10px 60px 20px 20px" }}
//             >
//               <div className="grid-container-ques-paper-del">
//                 <div className="item2">
//                   <FormInputs
//                     label="Student Name"
//                     value={
//                       selectedStudent.length === 0
//                         ? ""
//                         : studentDetail.student_full_name || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item3">
//                   <FormInputs
//                     label="Status"
//                     value={
//                       selectedStudent.length === 0
//                         ? ""
//                         : studentDetail.status || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item4">
//                   <FormInputs
//                     label="Roll No"
//                     value={
//                       selectedStudent.length === 0
//                         ? ""
//                         : studentDetail.roll_number || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item5">
//                   <FormInputs
//                     label="Phone No"
//                     value={
//                       selectedStudent.length === 0
//                         ? ""
//                         : studentDetail.mobile_number || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item6">
//                   <FormInputs
//                     label="Class Type"
//                     value={
//                       selectedStudent.length === 0
//                         ? ""
//                         : studentDetail.class_type || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div>
//                   <FormInputs
//                     label="Batch Name"
//                     value={
//                       selectedStudent.length === 0
//                         ? ""
//                         : studentDetail.batch_name || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item2">
//                   <FormInputs
//                     label="Course Name"
//                     value={
//                       selectedStudent.length === 0
//                         ? ""
//                         : studentDetail.course_name || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GenerateOTLC;










// // const [students, setStudents] = useState([]);
//   // const otlcRef = useRef(null);
//   // const [isCopied, setIsCopied] = useState(false);

// // const copyToClipboard = () => {
// //     if (otlc) {
// //       navigator.clipboard.writeText(otlc);
// //       setIsCopied(true);
// //       setTimeout(() => setIsCopied(false), 5000);
// //     }
// //   };
//  {/* GENERATE CODE SECTION */}
//       {/* <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ONE TIME LOGIN CODE</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div
//             className="select-assign-test-container-ques-pap-del"
//             style={{ padding: "10px 60px 20px 20px" }}
//           >
//             <div>
//               <input
//                 className="input-otc-2"
//                 type="text"
//                 disabled
//                 value={otlc}
//                 ref={otlcRef}
//                 style={{ flex: 1 }}
//               />
//               {otlc && (
//                 <button className="button-box-copy" onClick={copyToClipboard}>
//                   <img src={copy_image} alt="copy" className="copy-otc" />
//                 </button>
//               )}
//             </div>
//             {isCopied && (
//               <span className="copy-message">Copied successfully</span>
//             )}
//           </div>
//         </div>
//       </div> */}












// =========================================================================================














import React, { useState, useEffect, useRef } from "react";
import "./OTC.css";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import SelectDropdown from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import InfoIcon from "../../Assets/Images/CommanImages/Informative.png";
import EndPoints from "../../Api/EndPoints";
import { useLocation, useNavigate } from "react-router-dom";

const GenerateOTLC = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setNoTimeSet,
  setShowCloseButton,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Students passed from StudentDashboard via navigate state
  // We only handle the first selected student (single-student flow on this page)
  const passedStudents = location.state?.students || [];
  const passedStudent = passedStudents[0] || null;

  const [otlc, setOtlc] = useState("");
  const [isOpenDetails, setIsOpenDetails] = useState(true);
  const [isOpenAccess, setIsOpenAccess] = useState(true);

  // Edit mode: false = view mode (sections disabled), true = edit mode (2nd section enabled)
  const [isEditMode, setIsEditMode] = useState(false);

  // Student details (Section 1 – always disabled)
  const [studentDetail, setStudentDetail] = useState({
    studentName: "",
    rollNo: "",
    course: "",
    batch: "",
    classType: "",
    phoneNumber: "",
    status: "",
    studentId: "",
  });

  // Student App Access values (Section 2 – editable in edit mode)
  const [studentAppAccess, setStudentAppAccess] = useState("No");
  const [parentAppAccess, setParentAppAccess] = useState("No");

  // Track original values to detect changes
  const [originalStudentAppAccess, setOriginalStudentAppAccess] = useState("No");
  const [originalParentAppAccess, setOriginalParentAppAccess] = useState("No");

  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const screenArray = dataClient?.client_schema_name?.[2] || [];
  const studentAccessScreen = screenArray.find(screen => screen.LVL2 === "Student access");
  const screenId = studentAccessScreen?.screen_id || 0;

  // Populate from passed student when component mounts
  useEffect(() => {
    if (passedStudent) {
      setStudentDetail({
        studentName:  passedStudent.studentName || "",
        rollNo:       passedStudent.rollNo || "",
        course:       passedStudent.course || "",
        batch:        passedStudent.batch || "",
        classType:    passedStudent.classType || "",
        phoneNumber:  passedStudent.phoneNumber || "",
        status:       passedStudent.status || "",
        studentId:    passedStudent.studentId || "",
      });
      setStudentAppAccess(passedStudent.studentAppAccess || "No");
      setParentAppAccess(passedStudent.parentAppAccess || "No");
      // Snapshot originals so we can detect changes later
      setOriginalStudentAppAccess(passedStudent.studentAppAccess || "No");
      setOriginalParentAppAccess(passedStudent.parentAppAccess || "No");
    }
  }, []);

  const toggleAccordionDetails = () => setIsOpenDetails((prev) => !prev);
  const toggleAccordionAccess = () => setIsOpenAccess((prev) => !prev);

  // Generate OTLC
  const generateOtc = async () => {
    if (!studentDetail.rollNo) {
      setShowCloseButton(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>No student selected. Please go back and select a student.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    try {
      const response = await fetch(
        `${EndPoints.GENERATE_STUDENT_OTLC_V2}?roll_number=${studentDetail.rollNo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_name: userName,
            client_branch_id: clientBranchId,
            screen_event_id: 37,
            screen_id: screenId,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok || data.status_code !== 200) {
        setShowCloseButton(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{data.message || "Failed to generate OTLC"}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }

      const generatedOtlc = data.otlc || "";
      setOtlc(generatedOtlc);

      if (generatedOtlc) {
        navigator.clipboard.writeText(generatedOtlc);
      }

      setNoTimeSet(true);
      setShowCloseButton(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ cursor: "pointer" }}>
              {data.message || "OTLC created successfully"} and copied to clipboard.{" "}
              <strong>Code: {generatedOtlc}</strong>
            </span>
          </div>
        </div>
      );
      setActiveImg(InfoIcon);
    } catch (error) {
      console.error("Error generating OTLC:", error);
      setShowCloseButton(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>An error occurred while generating OTLC</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  // Save student app access
  const handleSave = async () => {
    if (!studentDetail.studentId) {
      setShowCloseButton(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Student ID is missing. Cannot save.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    // Guard: both dropdowns must have a value
    if (hasEmptyAccess) {
      setShowCloseButton(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select values for both Student App Access and Parent App Access.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    // Guard: nothing changed
    if (!hasChanges) {
      setShowCloseButton(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>No changes detected. Please update at least one field before saving.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    try {
      const payload = {
        student_id: Number(studentDetail.studentId),
        student_app_access: studentAppAccess === "Yes",
        parent_app_access: parentAppAccess === "Yes",
        last_modified_by: userName || "",
      };

      const response = await fetch(
        `${EndPoints.UPDATE_STUDENT_APP_ACCESS || (EndPoints.BASE_URL || "").replace(/\/$/, "") + "/update-student-app-access/"}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("other")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setShowCloseButton(true);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{data.message || "Failed to update student app access"}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }

      // Success → back to dashboard
      // setNoTimeSet(false);
      // setShowCloseButton(false);
      // setIsMessageBoxVisible(true);
      // setMessageBox(
      //   <div className="Container-messageBOX">
      //     <div className="messagebox-insider1">
      //       <div className="loader-tc"></div>
      //       <span>{data.message || "Student app access updated successfully"}</span>
      //     </div>
      //   </div>
      // );
      // setActiveImg(InfoIcon);

      // setTimeout(() => {
      //   setIsMessageBoxVisible(false);
      //   navigate("/studentdashboard");
      // }, 1500);

      
      setOriginalStudentAppAccess(studentAppAccess);
      setOriginalParentAppAccess(parentAppAccess);
      setIsEditMode(false);

      setNoTimeSet(false);
      // setShowCloseButton(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{data.message || "Student app access updated successfully"}</span>
          </div>
        </div>
      );
      setActiveImg(InfoIcon);

    } catch (error) {
      console.error("Error saving student app access:", error);
      setShowCloseButton(true);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>An error occurred while saving access settings</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  // Handle Cancel → go back to dashboard
  const handleCancel = () => {
    navigate("/studentdashboard");
  };

  // Toggle Edit/Save
  const handleEditOrSave = () => {
    if (isEditMode) {
      handleSave();
    } else {
      setIsEditMode(true);
    }
  };

  // SAVE is enabled only when: edit mode is active AND something changed AND neither field is empty
  const hasChanges =
    studentAppAccess !== originalStudentAppAccess ||
    parentAppAccess  !== originalParentAppAccess;

  const hasEmptyAccess = !studentAppAccess || !parentAppAccess;

  const canSave = isEditMode && hasChanges && !hasEmptyAccess;

  // GENERATE OTLC is disabled when:
  // 1. Student status is Inactive
  // 2. Student App Access is "No"
  // 3. Edit mode is active (unsaved changes in progress)
  const isInactive = studentDetail.status?.toLowerCase() === "inactive";
  const hasNoAppAccess = studentAppAccess !== "Yes";
  const canGenerateOtlc = !isInactive && !hasNoAppAccess && !isEditMode;

  return (
    <div className="create-role-container">
      {/* Header with three buttons – all using create-test-section-btn for uniform style */}
      <div className="create-role-container-ques-paper-del">
        {/* <span className="create-role-heading">Generate One Time Login Code</span> */}
        <span className="create-role-heading">Manage App Access</span>
        <div className="cr-header-btn-container" style={{ display: "flex", gap: "10px", alignItems: "center" }}>

          {/* Cancel – extra horizontal padding for more breathing room */}
          <button
            className="create-test-section-btn"
            style={{
              boxShadow: "0px 4px 4px 0px #00000040",
              padding: "8px 24px",
              minWidth: "105px",
              marginRight: "0",
              marginLeft: "0",
              marginTop: "0",
            }}
            onClick={handleCancel}
          >
            CANCEL
          </button>

          {/* Generate OTLC – disabled if inactive, no app access, or edit in progress */}
          <button
            className="create-test-section-btn"
            style={{
              boxShadow: "0px 4px 4px 0px #00000040",
              padding: "8px 16px",
              minWidth: "150px",
              marginRight: "0",
              marginLeft: "0",
              marginTop: "0",
              opacity: canGenerateOtlc ? 1 : 0.4,
              cursor: canGenerateOtlc ? "pointer" : "not-allowed",
            }}
            onClick={generateOtc}
            disabled={!canGenerateOtlc}
          >
            GENERATE OTLC
          </button>

          {/* Edit / Save */}
          <button
            className="create-test-section-btn"
            style={{
              boxShadow: "0px 4px 4px 0px #00000040",
              padding: "8px 16px",
              marginRight: "0",
              marginLeft: "0",
              marginTop: "0",
              // When in edit mode but canSave is false, dim it
              opacity: isEditMode && !canSave ? 0.4 : 1,
              cursor: isEditMode && !canSave ? "not-allowed" : "pointer",
            }}
            onClick={handleEditOrSave}
            disabled={isEditMode && !canSave}
          >
            {isEditMode ? "SAVE" : "EDIT"}
          </button>

        </div>
      </div>

      {/* SECTION 1: STUDENT DETAILS */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>STUDENT DETAILS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionDetails}>
            {isOpenDetails ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenDetails && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "10px 60px 20px 20px" }}
            >
              <div className="grid-container-ques-paper-del">
                {/* Row 1: Student Name, Roll No, Course */}
                <div className="item2">
                  <FormInputs
                    label="Student Name"
                    value={studentDetail.studentName || ""}
                    disabled
                  />
                </div>
                <div className="item3">
                  <FormInputs
                    label="Roll No"
                    value={studentDetail.rollNo || ""}
                    disabled
                  />
                </div>
                {/* Row 2: Course, Batch */}
                <div className="item4">
                  <FormInputs
                    label="Course"
                    value={studentDetail.course || ""}
                    disabled
                  />
                </div>
                <div className="item5">
                  <FormInputs
                    label="Batch"
                    value={studentDetail.batch || ""}
                    disabled
                  />
                </div>
                {/* Row 3: Class Type, Phone Number */}
                <div className="item6">
                  <FormInputs
                    label="Class Type"
                    value={studentDetail.classType || ""}
                    disabled
                  />
                </div>
                <div>
                  <FormInputs
                    label="Phone No. (Student)"
                    value={studentDetail.phoneNumber || ""}
                    disabled
                  />
                </div>
                {/* Row 4: Status */}
                <div className="item2">
                  <FormInputs
                    label="Status"
                    value={studentDetail.status || ""}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* SECTION 2: STUDENT ACCESS */}
      <div className="ques-paper-del" style={{ marginTop: "16px" }}>
        <div className="personal-header">
          <div className="header">
            <label>STUDENT ACCESS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionAccess}>
            {isOpenAccess ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenAccess && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "10px 60px 20px 20px" }}
            >
              <div className="grid-container-ques-paper-del">
                {/* Student App Access Dropdown */}
                <div className="item2">
                  <SelectDropdown
                    label="Student App Access"
                    width="100%"
                    selected={studentAppAccess}
                    setSelected={setStudentAppAccess}
                    options={[
                      { id: "Yes", label: "Yes" },
                      { id: "No",  label: "No"  },
                    ]}
                    placeholder="Select..."
                    disabled={!isEditMode}
                    isRequired={true}
                  />
                </div>

                {/* Parent App Access Dropdown */}
                <div className="item3">
                  <SelectDropdown
                    label="Parent App Access"
                    width="100%"
                    selected={parentAppAccess}
                    setSelected={setParentAppAccess}
                    options={[
                      { id: "Yes", label: "Yes" },
                      { id: "No",  label: "No"  },
                    ]}
                    placeholder="Select..."
                    disabled={!isEditMode}
                    isRequired={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GenerateOTLC;